import { useEffect, useState } from "react";
import { setModalJuryPostulate } from "../../../redux/actions/juradosAction"
import { useDispatch, useSelector } from 'react-redux';
import TabComponent from './tab/index'
import Accordion from './Accordion'
import ModalJuryPostulate from '../ModalJury/ModalJuryPostulate';
import ModalDocument from './ModalDocument/modalDocument'
import {
    Modal,
    Card,
    Button,
    Icon,
    CardContent,
    CardHeader,
    CardDescription,
} from "semantic-ui-react";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import axios from "axios";
import apiNotificaciones from '../../../api/Notificaciones/api-notificaciones';
import { RootState } from '../../../redux/reducers';




const ModalVerJurados1 = ({ setJurados, primeroDatostabla, datos, userState, handleClickTab, changeState, buttonPostulation, enableObservation }: any) => {
    const participante = useSelector((state: RootState) => state.participantes);
    const [photo] = useState("")
    const [openModal, setOpenModal] = useState(false);
    const [documento, setDocumento] = useState(false);
    const [status, setStatus] = useState()
    const handleOpenModal = (document: any) => {
        if (document !== null) {
            let url: any = `${process.env.REACT_APP_SERVER_DOCU}consultarArchivos/${document}`
            setDocumento(url);
        }
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setDocumento(false)
        setOpenModal(false)
    }

    const handleOpen = () => {
        setOpen(true)
        localStorage.setItem('jury', datos.id_jurado)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);
    const [observacionData, setObservacionData] = useState({
        observacion: '',
        status: true
    } as any)
    const [stepOne, setStepOne] = useState(false);
    const [showButton, setShowButton] = useState();
    const [check, setCheck] = useState({
        checked: true
    })
    const [idObservacion, setIdObservacion] = useState({} as any)
    const handleButtonPostular = () => {
        putObservation()
        dispatch(setModalJuryPostulate(true))
        setOpen(false)
        primeroDatostabla()

    }
    const juradoState = datos

    const handleCerrarBoton = () => {
        getNoPostularJurado()
        putObservation()
        setOpen(false)
        getStatus()
        primeroDatostabla()

    }
    const handleButtonCerrar = () => {
        setOpen(false)
    }
    const handleButtonCerrarGuardar = () => {
        putObservation()
        setOpen(false)
        getStatus()
        primeroDatostabla()
    }

    const getStatus = async () => {
        await axios.get(`${process.env.REACT_APP_SERVER_JURA2}juries/status/change?id=${localStorage.getItem('jury')}&status=${status}`)
    }

    const getNoPostularJurado = async () => {
        await axios.get(`${process.env.REACT_APP_SERVER_JURA2}juries/reject/${localStorage.getItem('jury')}`)
    }

    const getIdPostularJurado = async () => {
        await axios.get(`${process.env.REACT_APP_SERVER_JURA2}juries/approve/${localStorage.getItem('jury')}`)
    }

    const getObservations = async () => {
        let response = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}observations/jury/${datos.id_jurado}`)
        //console.log(response)

        setObservacionData(response.data.items[0]?.observation)
        setIdObservacion(response.data?.items[0])

    }


    const putObservation = async () => {
        const method = idObservacion?.id ? 'put' : 'post'

        await axios[method](`${process.env.REACT_APP_SERVER_JURA2}observations${idObservacion?.id ? `/${idObservacion?.id}` : ''}`,
            {
                observation: observacionData,
                resume_id: datos.id_jurado
            }).then((resp) => {
            }).catch((err) => {
            })

        primeroDatostabla();

        let payloadNotificacionAdmin = {
            nombre_jurado: `${juradoState.primer_nombre} ${juradoState.segundo_nombre} ${juradoState.primer_apellido} ${juradoState.segundo_apellido}`,
            tipo_notificacion: "Postulacion jurado",
            remitente: participante.idParticipante,
        }

        await apiNotificaciones.enviarNotificacionAdministrador(payloadNotificacionAdmin);
    }

    useEffect(() => {
        getObservations()


    }, [])

    const handleJuradoPostulado = (observacion: any) => {
        console.log(observacion)


    }
    const handleChangeButton = (check: any) => {
        setShowButton(check.checked)
        setCheck(check.checked)
        console.log(check.checked)
    }

    const handleObservacion = (value: any) => {

        setObservacionData(value)
        return observacionData




    }

    let photoProfile

    if (datos.path_foto !== null) {
        photoProfile = `${process.env.REACT_APP_SERVER_DOCU}consultarArchivos/${datos?.path_foto}`
    } else {
        photoProfile = false
    }

    console.log('juradosss --->', datos)

    return (
        <div>
            <Modal
                size="fullscreen"
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
                centered={false}
                closeIcon={
                    <Icon
                        name="x"
                        style={{
                            color: "#9F0505",
                            position: "absolute",
                            right: 20,
                            top: 25,
                            cursor: "pointer",
                        }}
                    />
                }
                className="modal-jurado"
                trigger={<span className="ver_convocatoria no-margin">Ver más</span>}
            >
                <Modal.Header className="font-size-12px font-family-Work-Sans">
                    Postulación a jurado{" "}
                    <span className="font-size-14px font-family-Work-Sans">
                        Código {datos.id_jurado}
                    </span>
                </Modal.Header>
                <Modal.Content style={{ display: "flex" }} scrolling>
                    <Modal.Description style={{ width: "5%" }} className="card-jurado">
                        <Card className="card-jurado-main">
                            <CardContent className="card-jurado-content">
                                {userState &&
                                    <>
                                        {photoProfile ? <Avatar size={127} src={photoProfile} style={{ margin: "1rem" }}
                                        />
                                            :
                                            <Avatar size={127} icon={<UserOutlined />} />}
                                    </>
                                }
                                <CardHeader style={{ display: 'flex', justifyContent: 'center' }}>
                                    <h3 style={{ fontWeight: 700 }}>{datos.primer_nombre}</h3>
                                    <h3 style={{ marginLeft: '3px', fontWeight: 700 }}> {datos.segundo_nombre}</h3>



                                </CardHeader>
                                <CardHeader style={{ display: 'flex', justifyContent: 'center' }}>

                                    <h3 style={{ marginLeft: '3px', fontWeight: 700 }}> {datos.primer_apellido}</h3>
                                    <h3 style={{ marginLeft: '3px', fontWeight: 700 }}>{datos.segundo_apellido}</h3>


                                </CardHeader>
                                {userState && (
                                    <>
                                        <CardDescription>
                                            Tipo de documento:  <span className="font-size-12px font-family-Work-Sans"
                                            > {datos.tipo_identificacion}</span>
                                        </CardDescription>
                                        <CardDescription>
                                            Nro documento <span className="font-size-12px font-family-Work-Sans"
                                            >{datos.numero_documento}</span>
                                        </CardDescription>
                                    </>
                                )}
                                <CardDescription>
                                    País: <span className="font-size-12px font-family-Work-Sans"
                                    >{datos.pais_nacimiento}</span>
                                </CardDescription>
                                {datos.departamento_residencia ?
                                    <CardDescription style={{ display: 'flex', alignItems: 'end' }}>
                                        Departamento:  <span style={{ marginLeft: '2px' }} className="font-size-12px font-family-Work-Sans">
                                            {datos.departamento_residencia}
                                        </span>
                                    </CardDescription> : null
                                }
                                {datos.municipio_residencia ?
                                    <CardDescription >
                                        Municipio: <span className="font-size-12px font-family-Work-Sans"
                                        >{datos.municipio_residencia}</span>
                                    </CardDescription> : null
                                }

                                {userState && (
                                    <>
                                        <CardDescription>
                                            Cel: <span className="font-size-12px font-family-Work-Sans"
                                            >{datos.telefono_celular}</span>
                                        </CardDescription>
                                        <CardDescription>
                                            <span>{datos.correo_electronico}</span>
                                        </CardDescription>
                                    </>
                                )}
                            </CardContent>
                        </Card>{" "}
                    </Modal.Description>

                    <Modal.Description
                        style={{ width: "58%", height: "100%", boxShadow: "none" }}
                    >
                        <TabComponent setCheck={setCheck} check={check} photo={photo} handleOpenModal={handleOpenModal} handleCloseModal={handleCloseModal} handleObservacion={handleObservacion} changeState={handleChangeButton} buttonPostulation={handleJuradoPostulado} datos={datos} userState={userState} observacionData={observacionData} handleClickTab={handleClickTab} setStatus={setStatus} status={status} />

                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions
                    style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        boxShadow: "none",
                    }}
                >
                    <br />
                    <Button

                        onClick={handleButtonCerrar}
                        className="button-gray-ghost"
                    >
                        Cerrar
                    </Button>
                    {!userState && (
                        <>
                            {showButton === false &&
                                <Button onClick={handleCerrarBoton}
                                    className="button-azul-radius">
                                    Guardar y cerrar
                                </Button>}

                            {showButton && <Button
                                value="Postulado"
                                onClick={handleButtonPostular}
                                className="button-azul-radius"
                            >
                                Postular jurado
                            </Button>}
                        </>

                    )}
                    {handleClickTab && (
                        <Button

                            onClick={handleButtonCerrarGuardar}
                            className="button-azul-radius"
                        >
                            Guardar y cerrar
                        </Button>
                    )

                    }


                </Modal.Actions>
            </Modal>
            <Modal
                size="fullscreen"
                className="modal-jurado"
                onClose={() => setStepOne(false)}
                open={stepOne}
            >
                <Modal.Header>
                    Selecciona las lineas y categorías para el jurado
                </Modal.Header>
                <Modal.Content scrolling>
                    <Accordion />
                </Modal.Content>
                <Modal.Actions
                    style={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        boxShadow: "none",
                    }}
                >
                    <Button
                        content="cancelar"
                        className="btn"
                        onClick={() => setStepOne(false)}
                    />
                    <Button
                        content="Finalizar postulación de jurado"
                        className="btn"
                        onClick={() => setStepOne(false)}
                        primary
                    />
                </Modal.Actions>
            </Modal>
            <ModalJuryPostulate getIdPostularJurado={getIdPostularJurado} />
            <ModalDocument handleOpenModal={handleOpenModal} handleCloseModal={handleCloseModal} openModal={openModal} documento={documento} />
        </div>
    )
}


export default ModalVerJurados1
